import React from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import DraggableCardField from '../dnd/DraggableCardField';
import CardFieldDropHandler from '../dnd/CardFieldDropHandler';
import ItemList from 'javascripts/dnd/components/ItemList';
import CardPreviewField from './CardPreviewField';
import { type CardGroup } from 'components/framework/models';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';

interface CardPreviewGroupProps {
  group: CardGroup;
}

const CardPreviewGroup: React.FC<CardPreviewGroupProps> = ({ group }) => {
  const controller = useController(CardLayoutEditorController);

  return (
    <aha-card-group>
      <ItemList
        items={group.fields}
        listKey={group.id}
        createDraggableItem={item =>
          new DraggableCardField({
            controller,
            item,
          })
        }
        createDropHandler={item =>
          new CardFieldDropHandler({
            controller,
            groupId: group.id,
            listKey: group.id,
          })
        }
        listLayout='horizontal'
        ItemComponent={CardPreviewField}
      />
    </aha-card-group>
  );
};

export default view(CardPreviewGroup);
